import { ENABLE_BRAND_MULTI_USER_PHASE_1_240223 } from "@faire/web-api/indigofair/settings/ENABLE_BRAND_MULTI_USER_PHASE_1_240223";

import { getSettingValueWithoutAssignment } from "./__internal__/getSetting";

export const getSettingEnableBrandMultiUserPhaseOne = (): boolean =>
  getSettingValueWithoutAssignment(
    ENABLE_BRAND_MULTI_USER_PHASE_1_240223,
    false
  );
